export default __webpack_public_path__ + "static/iconography-image-e-f9cab51da07f48df7c60249b3cd62680e385cee0e9f40cb289ce43c17deb6f03.png";